import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import { useAuth } from "../AuthContext";
import iziToast from "izitoast";
import Footer from "./Footer";

export const AddTest = () => {

    const { apipath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const organizationId = localStorage.getItem('testOrganization');
    const examId = localStorage.getItem('testExam');
    // const examQues = localStorage.getItem('testQues');
    const [organizations, setOrganizations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [exams, setExams] = useState([]);
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [activeTab, setActiveTab] = useState("Test");
    const [formData, setFormData] = useState({
        organization: organizationId,
        exam: examId,
        test_name: "",
        total_questions: 0,
        marks: "",
        code: "",
        description: "",
        image: null,
        duration: "",
        // start_time: "",
        // result_time: "",
    });

    useEffect(() => {
        const getOrganizations = async () => {
            try {
                const response = await axios.post(
                    apipath + '/organizations',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    return false;
                }
                setOrganizations(response.data.organizations);
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }

            } finally {

            }
        }
        getOrganizations();
    }, []);


    const getExams = async () => {
        try {
            console.log(formData.organization);
            const response = await axios.post(
                apipath + '/exams',
                { 'id': formData.organization },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setExams(response.data.exams);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {

        }
    }
    useEffect(() => {
        getExams();
    }, [formData.organization]);
    useEffect(() => {
        const selectedOption = document.getElementById('exam_name').options[document.getElementById('exam_name').selectedIndex];
        const questions = selectedOption.getAttribute('data-questions') ?? 0;
        // console.log(questions);
        setTotalQuestions(questions);
        setFormData({
            ...formData,
            total_questions: questions,  // Reset exam when organization changes
        });
    }, [exams]);


    const [errors, setErrors] = useState({});

    const handleOrganizationChange = (e) => {
        setTotalQuestions(0);
        setFormData({
            ...formData,
            organization: e.target.value,
            exam: "",  // Reset exam when organization changes
            total_questions: 0,
        });
    };
    const handleExamChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const questions = selectedOption.getAttribute('data-questions') ?? 0;
        setTotalQuestions(questions);
        setFormData({
            ...formData,
            exam: e.target.value,
            total_questions: questions,  // Reset exam when organization changes
        });
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: files ? files[0] : value,
        }));
        // console.log(formData);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.exam) newErrors.exam = "Exam name is required";
        if (!formData.organization) newErrors.organization = "Organization is required";
        if (!formData.test_name) newErrors.test_name = "Test name is required";
        // if (!formData.total_questions || isNaN(formData.total_questions))
        //     newErrors.total_questions = "Valid number of questions is required";
        if (!formData.marks || isNaN(formData.marks))
            newErrors.marks = "Valid total marks are required";
        if (!formData.code) newErrors.code = "Test code is required";
        if (!formData.description) newErrors.description = "Description is required";
        if (!formData.image) newErrors.image = "Test image is required";
        if (!formData.duration || isNaN(formData.duration))
            newErrors.duration = "Valid duration is required";
        // if (!formData.start_time) newErrors.start_time = "Start date and time are required";
        // if (!formData.result_time) newErrors.result_time = "Result date and time are required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle file input change
    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first selected file
        setFormData({ ...formData, image: file }); // Set the file in the formData state

        // Optionally, add validation for file type/size
        if (file && !file.type.startsWith("image/")) {
            setErrors({ ...errors, image: "Please upload a valid image file" });
        } else {
            setErrors({ ...errors, image: null });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            // Handle form submission
            // console.log(formData);
            setIsLoading(true);

            try {
                const response = await axios.post(
                    apipath + '/add_test', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    return false;
                }
                else {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    localStorage.removeItem('testOrganization');
                    localStorage.removeItem('testExam');
                    // localStorage.removeItem('testQues');
                    navigate('/tests');
                }
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
            }
            finally {
                setIsLoading(false);
            }
        }
    };


    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"tests"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Add Test</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-cyan-900 to-cyan-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div className="w-full p-2">
                            <form onSubmit={handleSubmit} className="mx-auto p-4 space-y-6 bg-white rounded-lg shadow-lg max-h-[75vh] overflow-auto">
                                <h2 className="text-2xl font-bold text-teal-800 text-center">Create Test</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    {/* Select Organization */}
                                    <div>
                                        <label className="block font-medium">Select Organization</label>
                                        <select
                                            name="organization"
                                            value={formData.organization}
                                            onChange={handleOrganizationChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value={""}>Select Organization</option>
                                            {organizations.map((org) => {
                                                return (<>
                                                    <option value={org.id}>{org.name}</option>
                                                </>)
                                            })}
                                        </select>
                                        {errors.organization && <p className="text-red-500 text-sm">{errors.organization}</p>}
                                    </div>

                                    {/* Select Exam Name */}
                                    <div>
                                        <label className="block font-medium">Select Exam Name</label>
                                        <select
                                            name="exam"
                                            value={formData.exam}
                                            onChange={handleExamChange}
                                            id="exam_name"
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value="0">Select Exam</option>
                                            {exams.map((exm) => {
                                                return (<>
                                                    <option value={exm.id} data-questions={exm.total_questions}>{exm.exam_name}</option>
                                                </>)
                                            })}
                                        </select>
                                        {errors.exam && <p className="text-red-500 text-sm">{errors.exam}</p>}
                                    </div>

                                    {/* Test Name */}
                                    <div>
                                        <label className="block font-medium">Test Name</label>
                                        <input
                                            type="text"
                                            name="test_name"
                                            value={formData.test_name}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.test_name && <p className="text-red-500 text-sm">{errors.test_name}</p>}
                                    </div>

                                    {/* Number of Questions */}
                                    {/* <div>
                                        <label className="block font-medium">Number of Questions</label>
                                        <input
                                            type="number" disabled={(totalQuestions) ? true : false}
                                            name="total_questions"
                                            value={formData.total_questions}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.total_questions && <p className="text-red-500 text-sm">{errors.total_questions}</p>}
                                    </div> */}

                                    {/* Total Marks */}
                                    <div>
                                        <label className="block font-medium">Total Marks</label>
                                        <input
                                            type="number"
                                            name="marks"
                                            value={formData.marks}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.marks && <p className="text-red-500 text-sm">{errors.marks}</p>}
                                    </div>

                                    {/* Test Code */}
                                    <div>
                                        <label className="block font-medium">Test Code</label>
                                        <input
                                            type="text"
                                            name="code"
                                            value={formData.code}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.code && <p className="text-red-500 text-sm">{errors.code}</p>}
                                    </div>

                                    {/* Description */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Description</label>
                                        <textarea
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.description && <p className="text-red-500 text-sm">{errors.description}</p>}
                                    </div>

                                    {/* Image */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Image</label>
                                        <input
                                            type="file"
                                            name="image"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.image && <p className="text-red-500 text-sm">{errors.image}</p>}
                                    </div>

                                    {/* Duration */}
                                    <div>
                                        <label className="block font-medium">Duration (minutes)</label>
                                        <input
                                            type="number"
                                            name="duration"
                                            value={formData.duration}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.duration && <p className="text-red-500 text-sm">{errors.duration}</p>}
                                    </div>

                                    {/* Start Date and Time */}
                                    {/* <div>
                                        <label className="block font-medium">Start Date & Time</label>
                                        <input
                                            type="datetime-local"
                                            name="start_time"
                                            value={formData.start_time}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.start_time && <p className="text-red-500 text-sm">{errors.start_time}</p>}
                                    </div> */}

                                    {/* Result Date and Time */}
                                    {/* <div>
                                        <label className="block font-medium">Result Date & Time</label>
                                        <input
                                            type="datetime-local"
                                            name="result_time"
                                            value={formData.result_time}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.start_time && <p className="text-red-500 text-sm">{errors.result_time}</p>}
                                    </div> */}
                                </div>

                                <div className="text-center">
                                    <button type="submit" className="bg-teal-500 text-white px-6 py-2 rounded-md hover:bg-teal-600">
                                        Create Test
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};